import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Dropzone from "react-dropzone";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import AsyncSelect from "react-select/async";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import FormData from "form-data";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getVillage, resetVillageState } from "../../../store/village/action";
import { deleteFile } from "../../../store/file/action";
import { getBank } from "../../../store/bank/action";
import { resetCustomerGroupState, getCustomerGroup as onGetCustomerGroups, addNewCustomerGroup as onAddNewCustomerGroup, updateCustomerGroup as onUpdateCustomerGroup, deleteCustomerGroup as onDeleteCustomerGroup, getCustomerGroupLoading } from "../../../store/customerGroup/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";

const CustomerGroup = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [logo, setLogo] = useState(defaultImg);
  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const dispatch = useDispatch();

  const { customerGroups, isCustomerGroupCreated, isCustomerGroupSuccess, loading, error, villages, villageLoading, companies, companyLoading, clients, clientLoading, banks, bankLoading } = useSelector((state) => ({
    customerGroups: state.CustomerGroup.customerGroups,
    loading: state.CustomerGroup.loading,
    isCustomerGroupCreated: state.CustomerGroup.isCustomerGroupCreated,
    isCustomerGroupSuccess: state.CustomerGroup.isCustomerGroupSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    villages: state.Village.villages,
    villageLoading: state.Village.loading,
    error: state.CustomerGroup.error,
  }));

  const [customerGroupList, setCustomerGroupList] = useState([]);
  const [customerGroup, setCustomerGroup] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [customerGroupContactItem, setCustomerGroupContactItem] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [bankList, setBankList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);

  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  const statusGenderData = [
    {
      options: [
        { label: "Pria", value: "Pria" },
        { label: "Wanita", value: "Wanita" },
      ],
    }];

  const onClickDelete = (customerGroup) => {
    setCustomerGroup(customerGroup);
    setDeleteModal(true);
  };

  const onClickApprove = (customerGroup) => {
    setCustomerGroup(customerGroup);
    setApproveModal(true);
  };

  const handleDeleteCustomerGroup = () => {
    if (customerGroup) {
      dispatch(onDeleteCustomerGroup(customerGroup));
      setDeleteModal(false);
    }
  };

  const handleApproveCustomerGroup = () => {
    if (customerGroup) {
      customerGroup.setApprove = true;
      dispatch(onUpdateCustomerGroup(customerGroup));
      setApproveModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setCustomerGroupList(customerGroups);
  }, [customerGroups]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetCustomerGroupState());
      dispatch(onGetCustomerGroups());
      setIsSearch(true);
      dispatch(resetClientState());
      dispatch(getClient());
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setUserData(obj.data);
        if (obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method) {
          setRoles(obj?.data?.user?.user_position?.position_role.method);
        }
      }
      if (obj?.data) setUserType(obj?.data?.userType);
    }
  }, [dispatch, customerGroups, isSearch]);

  useEffect(() => {
    if (!isEmpty(customerGroups)) {
      setCustomerGroup(customerGroups);
      setCustomerGroupList(customerGroups);
      setInfo(customerGroups[customerGroups.length - 1]);
      setIsEdit(false);
    }
  }, [customerGroups]);

  const promiseOptions = (e) => {
    if (!villageLoading) {
      dispatch(resetVillageState());
      setVillageList([]);
      if (e.length > 3) {
        dispatch(getVillage({ title: e }));
      }
      return new Promise((resolve, reject) => {
        while (villageLoading);
        resolve(villageList);
      });
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  useEffect(() => {
    if (!isEmpty(villages)) {
      var villageData = [];
      var opt = [];
      villages.forEach((item, key) => {
        const village_name = item.village_name;
        const id = item.id;
        const city_name = item.vc.city_name;
        const district_name = item.vd.district_name;
        const province_name = item.vp.province_name;
        var obj = {
          label: village_name + ", " + district_name + ", " + city_name + " - " + province_name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      villageData.push(option);
      setVillageList(villageData);
    }
  }, [villages]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredCustomerGroups = customerGroups;
      if (type !== "all") {
        filteredCustomerGroups = customerGroups.filter((customerGroup) => customerGroup.customer_group_status.name === type);
      }
      setCustomerGroupList(filteredCustomerGroups);
    }
  };

  useEffect(() => {
    if (banks && !banks.length) {
      dispatch(getBank());
    }
  }, [dispatch, banks]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCustomerGroup(null);
      setCustomerGroupContactItem([]);
      setCompanyList([]);
      setPlaceDefaultVal("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = useCallback((id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  }, [dispatch]);

  const handleCustomerGroupClick = useCallback((arg) => {
    const customerGroup = arg;
    let venaddress = [];
    // let venbank = [];
    let vencustomerGroup = [];
    customerGroup.customer_group_address.forEach((address) => {
      if (address.isPrimary) venaddress = address;
    });
    const addressName = venaddress ? venaddress.address_name : "";
    const addressLabel = venaddress ? venaddress.description : "";
    const addressValue = venaddress ? venaddress.villageId : "";

    let address_customerGroup = {};
    for (const address of customerGroup.customer_group_address) {
      if (address.isPrimary) {
        address_customerGroup = address;
      }
    }

    // customerGroup.customer_group_bank.forEach((bank) => {
    //   if (bank.isPrimary) venbank = bank;
    // });

    if (customerGroup.customer_group_contact) {
      customerGroup.customer_group_contact.forEach((element) => {
        vencustomerGroup.push({
          id: element.id,
          name: element.name,
          email: element.email,
          phone: element.phone,
          position: element.position,
        });
      });
      setCustomerGroupContactItem(vencustomerGroup);
    }

    setPlaceDefaultVal({
      label: `${address_customerGroup.village} ${address_customerGroup.district} ${address_customerGroup.city} ${address_customerGroup.province} ${address_customerGroup.country}`,
      value: `${address_customerGroup.village} ${address_customerGroup.district} ${address_customerGroup.city} ${address_customerGroup.province} ${address_customerGroup.country}`,
    });

    setCustomerGroup({
      id: customerGroup.id,
      // idBank: venbank.id ?? 0,
      address: {
        label: `${address_customerGroup.village} ${address_customerGroup.district} ${address_customerGroup.city} ${address_customerGroup.province} ${address_customerGroup.country}`,
        value: `${address_customerGroup.village} ${address_customerGroup.district} ${address_customerGroup.city} ${address_customerGroup.province} ${address_customerGroup.country}`,
      },
      street: address_customerGroup.description ?? "",
      zip: address_customerGroup.code ?? "",

      village: address_customerGroup.village ?? "",
      district: address_customerGroup.district ?? "",
      city: address_customerGroup.city ?? "",
      province: address_customerGroup.province ?? "",
      country: address_customerGroup.country ?? "",
      name: customerGroup.name,
      email: customerGroup.email,
      phone: customerGroup.phone,
      fax: customerGroup.fax,
      image: customerGroup.image,
      // tax_number: customerGroup.tax_number,
      website: customerGroup.website,
      description: customerGroup.description,
      // number: venbank.number,
      // bank: venbank.bank_data_bank && {
      //   label: venbank.bank_data_bank.name,
      //   value: venbank.id,
      // },
      customer_group_status: {
        label: customerGroup.customer_group_status.name,
        value: customerGroup.customer_group_status.id,
      },

      customer_group_contact: vencustomerGroup,
      client:
        customerGroup.customer_group_client && {
          label: customerGroup.customer_group_client ? customerGroup.customer_group_client.name : "",
          value: customerGroup.customer_group_client ? customerGroup.customer_group_client.id : "",
        },
      company:
        customerGroup.customer_group_company && {
          label: customerGroup.customer_group_company ? customerGroup.customer_group_company.name : "",
          value: customerGroup.customer_group_company ? customerGroup.customer_group_company.id : "",
        },
    });

    handleGetCompany(customerGroup.customer_group_client.id)

    switch (userType) {
      case "admin":
        setIsDisabledUserType(false);
        break;

      default:
        if (userType === "client") {
          handleGetCompany(customerGroup.customer_group_client ? customerGroup.customer_group_client.id : "");
        }
        setIsDisabledUserType(true);
        break;
    }

    setIsEdit(true);
    toggle();
  }, [toggle, userType, handleGetCompany]);

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  setInfo(data);
                }}><i className="ri-eye-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleCustomerGroupClick(data);
                }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  onClickDelete(data);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
            {cellProps.row.original.statusId === 1 && (
              <button
                className="btn-label btn btn-sm btn-soft-success fs-12 ms-2"
                onClick={() => {
                  onClickApprove(data);
                }}>
                <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
              </button>
            )}
          </div>
        );
      },
    },
    {
      Header: "Nama",
      filterable: true,
      accessor: "name",
      Cell: (customerGroup) => (
        <>
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              {customerGroup.row.original.image ? (
                <img src={customerGroup.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${customerGroup.row.original.image}`} alt="" className="avatar-xs rounded-circle me-1" />
              ) : (
                <div className="flex-shrink-0 avatar-xs me-1">
                  <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{customerGroup.row.original.name.charAt(0)}</div>
                </div>
              )}
            </div>
            <div className="flex-grow-1 ms-2 name">{customerGroup.row.original.name}</div>
          </div>
        </>
      ),
    },
    {
      Header: "Phone",
      accessor: "phone",
      filterable: true,
    },
    {
      Header: "Email",
      accessor: "email",
      filterable: true,
    },
    {
      Header: "Website",
      accessor: "website",
      filterable: true,
    },
    {
      Header: "Status",
      accessor: "customer_group_status.name",
      filterable: true,
      Cell: (cell) => {
        switch (cell.value) {
          case "DRAFT":
            return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          case "ACTIVE":
            return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
          case "INACTIVE":
            return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
          default:
            return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
        }
      },
    }], [handleCustomerGroupClick, logo]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: customerGroupList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetCustomerGroups(param));
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (customerGroup && customerGroup.client) ?? "",
      company: (customerGroup && customerGroup.company) ?? "",
      name: (customerGroup && customerGroup.name) ?? "",
      email: (customerGroup && customerGroup.email) ?? "",
      password: (customerGroup && customerGroup.password) ?? "",
      phone: (customerGroup && customerGroup.phone) ?? "",
      birthat: (customerGroup && customerGroup.birthat) ?? "",
      fax: (customerGroup && customerGroup.fax) ?? "",
      tax_number: (customerGroup && customerGroup.tax_number) ?? "",
      number: (customerGroup && customerGroup.number) ?? "",
      website: (customerGroup && customerGroup.website) ?? "",
      description: (customerGroup && customerGroup.description) ?? "",
      address: (customerGroup && customerGroup.address) ?? "",
      customer_group_status: customerGroup && customerGroup.customer_group_status,
      village: customerGroup && customerGroup.village,
      bank: (customerGroup && customerGroup.bank) ?? "",
      idBank: (customerGroup && customerGroup.idBank) || 0,
      zip: (customerGroup && customerGroup.zip) ?? "",
      street: (customerGroup && customerGroup.street) ?? "",
      image: (customerGroup && customerGroup.image) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Customer Group Name").nullable(true),
      phone: Yup.string().required("Please Enter Phone Number").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCustomerGroupLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: customerGroup.id,
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.name,
          email: values.email,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : customerGroup.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : customerGroup.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : customerGroup.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : customerGroup.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : customerGroup.country,
          street: values.street,
          customer_group_contact: JSON.stringify(customerGroupContactItem),
          image: values.image,
        };

        dispatch(onUpdateCustomerGroup(editDataSubmit));
      } else {

        var addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,

          name: values.name,
          email: values.email,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          description: values.description,
          zip: values.zip,
          village: values.address.value.terms[0].value,
          district: values.address.value.terms[values.address.value.terms.length - 4].value,
          city: values.address.value.terms[values.address.value.terms.length - 3].value,
          province: values.address.value.terms[values.address.value.terms.length - 2].value,
          country: values.address.value.terms[values.address.value.terms.length - 1].value,
          street: values.street,
          customer_group_contact: JSON.stringify(customerGroupContactItem),
          image: values.image,
        };

        dispatch(onAddNewCustomerGroup(addDataSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  function handleCustomerGroupContactAdd() {
    let fc = [];
    if (customerGroupContactItem && customerGroupContactItem.length) {
      customerGroupContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setCustomerGroupContactItem(fc);
  }

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCustomerGroup(element.value));
    });
    checkall.checked = false;
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const setInputType = (type) => {
    if (userData) {
      switch (type) {
        case "user":
          setCustomerGroup({
            client:
              userData.clientId === null
                ? ""
                : {
                  label: userData.client_name ? userData.client_name : "",
                  value: userData.clientId ? userData.clientId : "",
                },
            company:
              userData.companyId === null
                ? ""
                : {
                  label: userData.company_name ? userData.company_name : "",
                  value: userData.companyId ? userData.companyId : "",
                },
          });
          setIsDisabledUserType(true);
          break;
        case "client":
          setCustomerGroup({
            client:
              userData.clientId === null
                ? ""
                : {
                  label: userData.client_name ? userData.client_name : "",
                  value: userData.clientId ? userData.clientId : "",
                },
          });
          handleGetCompany(userData.clientId);
          setIsDisabledUserType(true);
          break;
        case "company":
          setCustomerGroup({
            client:
              userData.clientId === null
                ? ""
                : {
                  label: userData.client_name ? userData.client_name : "",
                  value: userData.clientId ? userData.clientId : "",
                },
            company:
              userData.companyId === null
                ? ""
                : {
                  label: userData.company_name ? userData.company_name : "",
                  value: userData.companyId ? userData.companyId : "",
                },
          });
          setIsDisabledUserType(true);
          break;

        default:
          setCustomerGroup("");
          setIsDisabledUserType(false);
          break;
      }
    }
  };

  document.title = "CustomerGroups | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={customerGroupList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCustomerGroup} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={customerGroup && customerGroup.name ? customerGroup.name : ""} show={approveModal} onApproveClick={handleApproveCustomerGroup} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="CustomerGroups" pageTitle="Sales" />
        <Row>
          <Col xxl={8}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Customer Group Data &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn me-2"
                      id="create-btn"
                      onClick={() => {
                        setInputType(userType);
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-group-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                    <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>
                    <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className=" ri-group-line me-1 align-bottom fs-14"></i> ALL GROUP
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select
                                className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Select join date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }} /><i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page <strong> {pageIndex + 1} of {pageOptions.length}</strong></Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit CustomerGroup" : "Add CustomerGroup"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              placeholder="Pilih Grup Usaha"
                              isDisabled={isDisabledUserType}
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={companyList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="customerGroupname-field" className="form-label">
                              Customer Group Name    </Label>
                            <Input name="name" id="customerGroupname-field" className="form-control" placeholder="Enter customerGroup name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              Phone    </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Enter phone" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                            {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="website-field" className="form-label">
                              Website    </Label>
                            <Input name="website" id="website-field" className="form-control" placeholder="Enter website" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.website ?? ""} invalid={validation.touched.website && validation.errors.website ? true : false} />
                            {validation.touched.website && validation.errors.website ? <FormFeedback type="invalid">{validation.errors.website}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email    </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Enter email" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                            {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="fax-field" className="form-label">
                              Fax
                            </Label>
                            <Input name="fax" id="fax-field" className="form-control" placeholder="Enter fax" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.fax ?? ""} invalid={validation.touched.fax && validation.errors.fax ? true : false} />
                            {validation.touched.fax && validation.errors.fax ? <FormFeedback type="invalid">{validation.errors.fax}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Street    </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Enter Street name" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street} invalid={validation.touched.street && validation.errors.street ? true : false} />
                            {validation.touched.street && validation.errors.street ? <FormFeedback type="invalid">{validation.errors.street}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              {props.t("zip Code")} <span className="text-danger">*</span>
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} invalid={validation.touched.zip && validation.errors.zip ? true : false} />
                            {validation.touched.zip && validation.errors.zip ? <FormFeedback type="invalid">{validation.errors.zip}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              CustomerGroup Description (optional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Enter profile desc" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            {validation.touched.description && validation.errors.description ? <FormFeedback type="invalid">{validation.errors.description}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 position-relative">
                            <Label htmlFor="customer_group_contact" className="form-label">
                              CustomerGroup Contacts
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleCustomerGroupContactAdd();
                              }}><i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Add
                            </button>
                          </div>
                          {customerGroupContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Name              </Label>
                                      <Input
                                        name={`customerGroupContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Contact name"
                                        type="text"
                                        value={customerGroupContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerGroupContactItem.${i}.name`, e.target.value);
                                          customerGroupContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Phone
                                      </Label>
                                      <Input
                                        name={`customerGroupContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Contact phone"
                                        type="text"
                                        value={customerGroupContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerGroupContactItem.${i}.phone`, e.target.value);
                                          customerGroupContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email              </Label>
                                      <Input
                                        name={`customerGroupContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Contact email"
                                        type="text"
                                        value={customerGroupContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerGroupContactItem.${i}.email`, e.target.value);
                                          customerGroupContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Position              </Label>
                                      <Input
                                        name={`customerGroupContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Contact position"
                                        type="text"
                                        value={customerGroupContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerGroupContactItem.${i}.position`, e.target.value);
                                          customerGroupContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{
                                    width: "70px",
                                  }}
                                  onClick={() => {
                                    setCustomerGroupContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                    // let data = cellProps.row.original;
                                    // onClickDelete(data);
                                  }}>
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative">
                            <Label htmlFor="customer_group_contact" className="form-label">
                              Image
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}><i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("image", "");
                                    }}>
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add CustomerGroup"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />

              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                        GENERAL INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    Customer Contact
                                  </td>
                                </tr>
                                {info.customer_group_contact ? (
                                  info.customer_group_contact.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Name</td>
                                          <td className="p2">{row.name ? row.name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Email</td>
                                          <td className="p2">{row.email ? row.email : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Phone</td>
                                          <td className="p2">{row.phone ? row.phone : "-"} </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    INFORMASI ALAMAT
                                  </td>
                                </tr>
                                {info.customer_group_address ? (
                                  info.customer_group_address.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Address</td>
                                          <td className="p2">{row.village ? row.village : "-"}, {row.city ? row.city : "-"}, {row.district ? row.district : "-"}, {row.province ? row.province : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Street</td>
                                          <td className="p2">{row.description ? row.description : "-"} - {row.code ? row.code : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2" colSpan={"2"}></td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                        OTHER CONTACT INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <div className="col-lg-12">
                          {(info.customer_group_contact || []).map((row) => {
                            return (
                              <table className="table border table-responsive table-striped fs-13 mb-3" key={row.id}>
                                <tbody>
                                  <tr>
                                    <td className="p2">Name</td>
                                    <td className="p2">{row.name ? row.name : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Position</td>
                                    <td className="p2">{row.position ? row.position : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Email</td>
                                    <td className="p2">{row.email ? row.email : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Phone</td>
                                    <td className="p2">{row.phone ? row.phone : "-"} </td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })}
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                        OTHER INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2">Dibuat Oleh</td>
                              <td className="p2">{info.customer_group_createdby && info.customer_group_createdby.name ? info.customer_group_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Diedit Oleh</td>
                              <td className="p2">{info.customer_group_updatedby && info.customer_group_updatedby.name ? info.customer_group_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Approved By</td>
                              <td className="p2">{info.customer_group_approvedby && info.customer_group_approvedby.name ? info.customer_group_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CustomerGroup.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(CustomerGroup));
